import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['photo', 'banner', 'clearPhoto', 'clearBanner', 'photoInput', 'bannerInput'];

  connect() {
  }

  handlePhotoChange(event) {
    const file = event.target.files[0];
    console.log(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.photoTarget.src = event.target.result;
      };
      reader.readAsDataURL(file);
    }
    this.clearPhotoTarget.classList.remove('hidden');
  }

  handleBannerChange(event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.bannerTarget.src = event.target.result;
      };
      reader.readAsDataURL(file);
    }
    this.clearBannerTarget.classList.remove('hidden');
  }

  clearPhoto() {
    this.photoTarget.src = '';
    this.clearPhotoTarget.classList.add('hidden');
    this.photoInputTarget.value = '';
  }

  clearBanner() {
    this.bannerTarget.src = '';
    this.clearBannerTarget.classList.add('hidden');
    this.bannerInputTarget.value = '';
  }
}
